<form (ngSubmit) = "onSubmit()">
    <p-dialog  [(visible)]="displayDialog" 
      [modal]="true" 
      [positionTop]="50" 
      [maximizable]="true"
      [contentStyle]="{'min-width':'600px'}"
      (onHide)="dialogClose()">
      <p-header>
        <b>Inactivate Partner User</b>
      </p-header>
        <div class="ui-grid ui-grid-responsive formcontainer"> 
          <div>
            <div class="formgroup">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12"> 
                  <label for="Email">Are you sure you want to Inactivate Partner User: To remove (<span *ngIf="userRelationship.PersonDetail.LastName">{{userRelationship.PersonDetail.LastName}}, </span>{{userRelationship.PersonDetail.FirstName}})<br />
                    and their access to all Partnerships and Asset Groups, <br /> you must select a new Primary Contact for the following Partnership
                  </label>
                </div>
              </div>  
            </div>
            <div class="formgroup">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-12">
                    <app-change-primary-contact 
                      [PersonId]="userRelationship.PersonDetail.PersonId"
                      (RelationshipAndContactId)="mapRelationshipAndContactId($event)"
                      (IsPrimaryContactReady)="checkIsPrimaryContactReady($event)" >
                    </app-change-primary-contact>
                  </div>
                </div>
            </div>
          </div>
        </div>
      <p-footer>
          <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
          <button pButton type="submit" label="{{processing ? 'Processing' : 'Remove User'}}" 
            [disabled]="processing || !isPrimaryContactSelected"></button>
      </p-footer>
    </p-dialog>
    </form>